import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  cssVariables: true,
  palette: {
    mode: 'light',
    primary: {
      main: '#126a53',
      dark: '#0d5040',
      light: '#e4f2eb',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#e6b34f',
      dark: '#d68314',
      light: '#fdf4e0',
      contrastText: '#111c17',
    },
    error: {
      main: '#c94538',
      light: '#fdecea',
    },
    warning: {
      main: '#d68314',
      light: '#fdf0d8',
    },
    info: {
      main: '#2d7dd2',
      light: '#e6f1fb',
    },
    success: {
      main: '#14a373',
      light: '#e0f5ec',
    },
    background: {
      default: '#f5f8f6',
      paper: '#ffffff',
    },
    text: {
      primary: '#111c17',
      secondary: '#6b7c73',
    },
    divider: '#e3eae6',
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: '"Roboto", "Segoe UI", system-ui, sans-serif',
    h1: {
      fontSize: '1.75rem',
      fontWeight: 800,
      letterSpacing: '-0.3px',
    },
    h2: {
      fontSize: '1.375rem',
      fontWeight: 800,
      letterSpacing: '-0.3px',
    },
    h3: {
      fontSize: '1.0625rem',
      fontWeight: 800,
      letterSpacing: '-0.3px',
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          minHeight: 40,
          borderRadius: 10,
          paddingInline: 18,
          letterSpacing: '0.01em',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          color: '#111c17',
        },
      },
    },
    MuiCard: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          border: '1px solid #e3eae6',
          borderRadius: 16,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          borderRadius: 999,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#126a53',
          },
        },
        notchedOutline: {
          borderColor: '#d8e2dc',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#f0f5f2',
          color: '#496057',
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
        },
        root: {
          borderBottomColor: '#eef3f0',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 8,
          fontSize: 12,
        },
      },
    },
    MuiDialog: {
      defaultProps: {
        fullWidth: true,
        maxWidth: 'sm',
      },
    },
  },
});
